// extracted by mini-css-extract-plugin
export default {"formHeading":"BK-z","form":"CK-z","submitBtn":"DK-z","disabled":"EK-z","input":"FK-z","error":"GK-z","submitMsg":"HK-z","signIn":"IK-z"};